import { render } from "./AmendBookingSettings.vue?vue&type=template&id=aee0dd04&scoped=true&lang=pug"
import script from "./AmendBookingSettings.vue?vue&type=script&lang=ts"
export * from "./AmendBookingSettings.vue?vue&type=script&lang=ts"

import "./AmendBookingSettings.vue?vue&type=style&index=0&id=aee0dd04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aee0dd04"

export default script